import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import {
  FaMapMarkerAlt,
  FaEnvelope,
  FaPhoneAlt,
  FaRegClock,
  FaPaperPlane,
  FaYoutube,
} from "react-icons/fa";
import { supabase } from "../supabaseClient";
import "./Footer.scss";

const NewsletterBox = () => {
  return (
    <a href="mailto:vetizmirveterinerklinigi@gmail.com">
      <div className="newsletter-box">
        <div className="newsletter-box__left-part">
          <FaEnvelope className="icon" />
          <span className="text">
            Bize Sormak İstediğiniz Sorula Anında İletim Sağlayın
          </span>
        </div>

        <FaPaperPlane className="icon" />
      </div>
    </a>
  );
};

const MainFooter = () => {
  const [instagramPosts, setInstagramPosts] = useState([]);

  // 2. useEffect ile verileri çekiyoruz
  useEffect(() => {
    const fetchInstagramPosts = async () => {
      const { data, error } = await supabase
        .from("instagram_posts")
        .select("*")
        .order("created_at", { ascending: false })
        .limit(6); // En son 6 gönderiyi getir

      if (error) {
        console.error("Error fetching Instagram posts:", error);
      } else {
        setInstagramPosts(data);
      }
    };

    fetchInstagramPosts();
  }, []);

  return (
    <footer className="main-footer">
      <div className="footer-container">
        {/* Sütun 1: Hakkında */}
        <div className="footer-column about-us">
          <img
            src="/logo-white.png"
            alt="Pati Dostu Logo"
            className="footer-logo"
          />
          <p className="description">
            Patili dostlarınızın sağlığı ve mutluluğu bizim önceliğimiz.
            Deneyimli ekibimiz ve sevgi dolu yaklaşımımızla, doğru teşhis ve
            tedavi yöntemleri sunuyoruz. Sağlık kontrollerinden acil
            müdahalelere kadar her adımda yanınızdayız.
          </p>
        </div>

        {/* Sütun 2: Sayfalar */}
        <div className="footer-column pages">
          <h4 className="footer-title">Sayfalar</h4>
          <nav className="footer-nav">
            <NavLink to="/">Ana Sayfa</NavLink>
            <NavLink to="/hakkimizda">Hakkımızda</NavLink>
            <NavLink to="/pati-hikayeleri">Pati Hikayeleri</NavLink>
            <NavLink to="/hekimlerimizden">Hekimlerimizden</NavLink>
            <NavLink to="/iletisim">İletişim</NavLink>
          </nav>
        </div>

        {/* Sütun 3: Instagram */}
        <div className="footer-column instagram">
          <h4 className="footer-title">Instagram Postları</h4>
          <div className="instagram-grid">
            {instagramPosts.length > 0
              ? instagramPosts.map((post) => (
                  <a
                    href={post.post_url || "#"}
                    key={post.id}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={post.image_url}
                      alt={`Instagram Post ${post.id}`}
                    />
                  </a>
                ))
              : [...Array(6)].map((_, index) => (
                  <div key={index} className="placeholder-image"></div>
                ))}
          </div>
        </div>

        {/* Sütun 4: İletişim */}
        <div className="footer-column contact">
          <h4 className="footer-title">İletişim Bilgileri</h4>
          <div className="contact-item">
            <FaMapMarkerAlt className="icon" />
            <span>
              <a
                href="https://www.google.com/maps/place/Vet-+%C4%B0zmir+Veteriner+Klini%C4%9Fi/@38.4647753,27.1784055,17z/data=!3m1!4b1!4m6!3m5!1s0x14b97d4dc4df0e21:0x241ec15ce7c78030!8m2!3d38.4647753!4d27.1784055!16s%2Fg%2F11gh0l3rtz?entry=ttu&g_ep=EgoyMDI1MDcxMy4wIKXMDSoASAFQAw%3D%3D"
                target="_blank"
              >
                Tepekule, 2084/8. Sk. No:31 B, 35000 Bayraklı/İzmir
              </a>
            </span>
          </div>
          <div className="contact-item">
            <FaEnvelope className="icon" />
            <span>vetizmirveterinerklinigi@gmail.com</span>
          </div>
          <div className="contact-item">
            <FaPhoneAlt className="icon" />
            <span>+90 538 597 04 41</span>
          </div>
          <div className="contact-item">
            <FaRegClock className="icon" />
            <span>
              Hafta içi : 09.00 - 19.00 / Cumartesi : 09.00 - 19.00Pazar :
              Kapalı
            </span>
          </div>
          <div className="contact-item">
            <FaYoutube className="icon" />
            <span>
              <a
                href="https://www.youtube.com/@vetizmirveterinerklini%C4%9Fi"
                target="_blank"
              >
                Vet- İzmir Youtube
              </a>
            </span>
            {/* <span></span> */}
          </div>
        </div>
      </div>
    </footer>
  );
};

const Footer = () => {
  return (
    <div className="footer-wrapper">
      <NewsletterBox />
      <MainFooter />
    </div>
  );
};

export default Footer;
